angular.module('impactx.osu').controller('OsuLoginDialogCtrl', ['LoginService', '$mdDialog', 'osutan', 'themeFactory', OsuLoginDialogCtrl]);

function OsuLoginDialogCtrl(LoginService, $mdDialog, osutan, themeFactory)
{
    this.theme = themeFactory.getTheme();
    var vm = this;
    this.login = function(passwd){
        return LoginService.loginOsu(passwd, osutan).then(function () {
            if (LoginService.model.data.errorMessage)
            {
                $mdDialog.hide({errorMessage: LoginService.model.data.errorMessage, osuredirect: LoginService.model.data.osuredirect});
            }
        }, function (data) {
            vm.authErrors = data.authErrors;
        });
    };
}